export default {
  login: 'Login',
  errorLogList: 'Error Log',
  globalSearch: 'Global Search',
};
